import axios from 'axios'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import {
  Toast
} from 'vant'
import { getUrlParams, hasOwnPropertyObj } from '@/utils/utils'
import httpStatusCode from '@/constant/httpStatusCode'
import { getPa } from '@/utils/permission'

// http://api-test.newhopehg.com/
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL:process.env.VUE_APP_BASE_API,
  timeout: 50000, // request timeout
  responseType: 'json'
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      }
    }
    // 是否需要验签
    // const timestr = Date.parse(new Date())
    // const isEncryption = config.isEncryption || true
    // if (isEncryption) {
    //   config.headers['x-nh-client-id'] = process.env.VUE_APP_CLIENTID
    //   // 时间戳
    //   config.headers['x-nh-timestamp'] = timestr

    //   // 请求签名
    //   config.headers['x-nh-signature'] = signRequestParams(config, timestr, isEncryption, process.env.VUE_APP_RSA_PUBLIC_KEY, process.env.VUE_APP_CLIENTID)
    // }
    const token = getToken()
    // 如果 token 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (token) {
      config.headers['SSO-TOKEN'] = token
    }
    if (config.isLoading) {
      Toast.loading({
        message: '加载中',
        mask: true
      })
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    if (hasOwnPropertyObj(response.headers, 'accesstoken')) {
      // 更新token
      setToken(response.headers['accesstoken'])
    }
    if (response?.status !== httpStatusCode.HTTP_SUCCESS_CODE) {
      window.$vm.$toast({
        message: response.statusText || 'Error',
        duration: 3 * 1000
      })
      return Promise.reject(new Error(response.statusText || 'Error'))
    } else {
      // 业务系统的报文
      if (response.data && hasOwnPropertyObj(response.data, 'code')) {
        if (response.data.code === httpStatusCode.HTTP_SERVICE_SYSTEM_SUCCESS) {
          Toast.clear()
          return response.data
        } else if (response.data.code === httpStatusCode.HTTP_SERVICE_SYSTEM_TOKEN_OVERDUE || response.data.code === httpStatusCode.HTTP_SERVICE_SYSTEM_TOKEN_OVERDUE_STRING) {
          removeToken()
          // eslint-disable-next-line max-len
          // window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${process.env.VUE_APP_FEISHU_APP_ID}&redirect_uri=${process.env.VUE_APP_FEISHU_REDIRECT_URI}&state=${encodeURIComponent(`processInstanceId=${getUrlParams('processInstanceId')}&taskId=${getUrlParams('taskId')}`)}`
          window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${process.env.VUE_APP_FEISHU_APP_ID}&redirect_uri=${process.env.VUE_APP_FEISHU_REDIRECT_URI}&state=${encodeURIComponent(location.href)}`
        } else {
          Toast({
            message: response.data && response.data.msg || 'Error',
            duration: 3 * 1000
          })
          return Promise.reject(new Error(response.data && response.data.msg || 'Error'))
        }
      } else {
        // 微信开发平台返回的报文
        return response.data
      }
    }
  },
  (error) => {
    console.info('error=', error)
    Toast({
      message: 'Error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
